module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-transfer', {
    attrs: {
      "titles": ['Available', 'Enabled'],
      "data": _vm.handleChannelData
    },
    model: {
      value: (_vm.currentChannels),
      callback: function($$v) {
        _vm.currentChannels = $$v
      },
      expression: "currentChannels"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e82df8fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/channel/ChannelSelect.vue
// module id = 3413
// module chunks = 3